import { RootState } from '../../rootReducer'

export const selectAuthError = (state: RootState) => state.auth.authAction.error

export const selectAuthPending = (state: RootState) => state.auth.authAction.pending

export const selectAuthUser = (state: RootState) => state.auth.authUser
